(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["top-bar"]) return;
  try {
    
  jQuery(document).ready(function($) {
    $('.btn-close').on('click', function() {
      $(this).parents('.parent-close').slideUp();
    })
  });

  } catch(e) { console.error(e); }
})();
})();
